import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'root',
      redirect:'login'
    },
    {
      path: '/home',
      name: 'home',
      redirect:'home/index',
      // component: Home
      component: () => import(/* webpackChunkName: "about" */ './views/Home.vue'),
      children:[
		  {
			  path: '/home/index',
			  name: 'home.index',
			  meta: {title: "采购信息一览"},
			  component: () => import(/* webpackChunkName: "about" */ './views/tPurchase/List.vue')
		  },
		  {
			  path: 'tEvaluate',
			  name: 'tEvaluate',
			  meta: {title: "供应商评价管理"},
			  component: () => import(/* webpackChunkName: "about" */ './views/tEvaluate/List.vue')
		  },
		  {
			  path: 'tInquiry',
			  name: 'tInquiry',
			  meta: {title: "询价信息一览"},
			  component: () => import(/* webpackChunkName: "about" */ './views/tInquiry/List.vue')
		  },
		  {
			  path: 'tQuotation',
			  name: 'tQuotation',
			  meta: {title: "报价回复登录"},
			  component: () => import(/* webpackChunkName: "about" */ './views/tQuotation/List.vue')
		  },
        // {
        //   path: '/home/test',
        //   name: 'home.test',
        //   meta :{title:"测试tab"},//此处为规则配置页面 title为Tab显示的标题
        //   component: () => import(/* webpackChunkName: "about" */ './views/Tabs/Test.vue')
        // },
        // {
        //   path: '/home/hasparam/:name',
        //   name: 'home.hasparam',
        //   meta :{title:"带参数"},//此处为规则配置页面 title为Tab显示的标题
        //   component: () => import(/* webpackChunkName: "about" */ './views/Tabs/HasParam.vue'),
        //   props:true
        // },
		  //以下为SDN-APS业务开发使用
		  // 系统管理
		  {
			  path: 'userlist',
			  icon: 'pie-graph',
			  name: 'userlist',
			  meta :{title: '用户管理'},
			  component: () => import(/* webpackChunkName: "about" */ './views/user/List.vue')
		  },
		  {
			  path: '/userDetail/:name',
			  name: 'userDetail',
			  meta :{title: '用户管理'},
			  component: () => import(/* webpackChunkName: "about" */ './views/user/Detail.vue'),
			  props:true
		  },
		  {
			  path: 'rolelist',
			  icon: 'pie-graph',
			  name: 'rolelist',
			  meta :{title: '角色管理'},
			  component: () => import(/* webpackChunkName: "about" */ './views/role/List.vue')
		  },

		  {
			  path:'/roleDetail',
			  name:'roleDetail',
			  meta :{title: '权限分配'},
			  component: () => import(/* webpackChunkName: "about" */ './views/role/detail.vue')
			  // component: resolve => {
				//   require(['../views/role/detail.vue'], resolve);
			  // }
		  },
		  //主表管理
		  {
			  path:'mCode',
			  icon:'pie-graph',
			  name:'mCodeList',
			  meta :{title: '代码维护'},
			  component: () => import(/* webpackChunkName: "about" */ './views/mCode/List.vue')
		  },

		  //库存管理
		  // {
			//   path:'tRealtimeFillin',
			//   icon:'pie-graph',
			//   name:'tRealtimeFillinList',
			//   meta :{title: '采购信息一览'},
			//   component: () => import(/* webpackChunkName: "about" */ './views/tPurchase/List.vue')
		  // },
      ]
    },
    {
      path: '/login',
      name: 'login',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/Login.vue')
    },
	  {
		  path: '/changepassword',
		  name: 'changepassword',
		  // route level code-splitting
		  // this generates a separate chunk (about.[hash].js) for this route
		  // which is lazy-loaded when the route is visited.
		  component: () => import(/* webpackChunkName: "about" */ './views/changepassword.vue')
	  }
  ]
})



// WEBPACK FOOTER //
// ./src/router.js